export const NAMESPACE = 'StartStatistics';
export const LOAD_STATISTICS = 'StartStatistics/LOAD_STATISTICS';
